'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div className="container py-12">
          <div className="mx-auto max-w-xl text-center">
            <h2 className="text-2xl font-bold mb-4">500 - Something went wrong!</h2>
            <p className="text-neutral-600 mb-6">
              We apologize for the inconvenience. Please try again or contact us if the problem persists.
            </p>
            <button 
              onClick={() => reset()}
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  )
} 